/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import onboardingQuestions from "./onboardingQuestions";

export default onboardingQuestions;
